module.exports = __webpack_public_path__ + "img/header-12.3cd06383.png";